// PORoutesXL - Sprint 44 Fase 3 Vista 9.
import { Routes, Route } from 'react-router-dom';
import POListXL from './POListXL';
import POFormXL from './POFormXL';

export default function PORoutesXL() {
  return (
    <Routes>
      <Route index element={<POListXL />} />
      <Route path="create" element={<POFormXL />} />
      <Route path=":id/edit" element={<POFormXL />} />
    </Routes>
  );
}
